/* ---------------------------------------------------------------------------------------------------------------------
GLOBAL JS
--------------------------------------------------------------------------------------------------------------------- */
import "slick-carousel/slick/slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.scss"

jQuery(document).ready(function ($) {
    var locations = $('#locations .location');

    locations.each(function () {
        var $this = $(this);
        var $slider = $this.find('.location-gallery__images');
        var $sliderNav = $this.find('.location-gallery__thumbnails');

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: $sliderNav
        });

        $sliderNav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: $slider,
            dots: false,
            arrows: false,
            focusOnSelect: true
        });
    });
});
